import CloseableModal from './container'

export default CloseableModal
